import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import { 
  Map, FileText, Users, ClipboardList, Building2, 
  FileCheck, MessageSquare, Mail 
} from 'lucide-react';
import { usePermissions } from '../../hooks/usePermissions';

export default function AdminLayout() {
  const { canManageSystemSettings } = usePermissions();

  if (!canManageSystemSettings) {
    return <div>Access Denied</div>;
  }

  const navItems = [
    { to: 'lots', icon: Map, label: 'Lots' },
    { to: 'leases', icon: FileText, label: 'Leases' },
    { to: 'subleases', icon: FileCheck, label: 'Subleases' },
    { to: 'leaseholders', icon: Users, label: 'Leaseholders' },
    { to: 'applicants', icon: ClipboardList, label: 'Applicants' },
    { to: 'eoi-responses', icon: Mail, label: 'EOI Responses' },
    { to: 'applications', icon: Building2, label: 'Applications' }
  ];

  return (
    <div className="min-h-[calc(100vh-5rem)]">
      {/* Main Content */}
      <main className="flex-1 overflow-auto bg-gray-50">
        <div className="py-6 px-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
